import axios from "axios"

import { Response } from "pages/api/lockingSystem/fetchSavedLockingSystem"

const fetchSavedLockingSystem = async (
	accessToken: string,
	lockingSystemShoppingListId: string,
) => {
	try {
		const {
			data: { savedLockingSystem, isOwner },
		} = (await axios.get(
			`/api/lockingSystem/fetchSavedLockingSystem?lockingSystemShoppingListId=${lockingSystemShoppingListId}&accessToken=${accessToken}`,
		)) as {
			data: Response
		}

		return { savedLockingSystem, isOwner }
	} catch (err) {
		return null
	}
}

export default fetchSavedLockingSystem
